import { React, useEffect, useState } from "react";
import ico_rana from "../../../assets/icons/ico_rana.svg";
import img_rana_planta from "../../../assets/images/img_rana_planta.png";
import VideoGroupsBanner from "../../../components/videoGroupsBanner";
import GroupInfoSection from "../../../components/groupInfoSection";
import GoToPage from "../../../components/goToPage";
import GroupsVideoFooter from "../../../components/groupsVideoFooter";
const HerpetofaunaScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const bosque = "https://drive.google.com/uc?export=download&id=1tIJ6tOcvie2j2X2iOU0YxDypFkzvSFX0";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="bg-[#002E0F] h-full" style={{"min-height":"100vh"}}>
      {width > 1300 ? (
        <div className="grid overflow-hidden lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 lg:grid-rows-1  gap-0 w-full h-full bg-[#002E0F] absolute">
          <div className="z-1 relative w-full lg:h-full">
            <VideoGroupsBanner videoSource={bosque} left="10%" />
            <div className="h-full bg-[#002E0F] bottom-0 right-0 absolute z-30 pl-24 pt-10 pr-36">
              <GoToPage
                page="/grupos"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <img
            
              src={img_rana_planta}
              alt=""
              className="w-full bottom-0 absolute z-40 pr-44 pl-24"
            />
          </div>

          <GroupInfoSection
            webvrurl="https://niv5.vercel.app/"
            icon={ico_rana}
            title={<p>Herpetofauna</p>}
            subTitle={<p>Anfibios y reptiles</p>}
            textFirstTab={
              <p>
                La herpetofauna está compuesta por los anfibios (por ejemplo,
                ranas, sapos, salamandras) y los reptiles (tortugas, serpientes,
                cocodrilos, lagartijas, etc.). Los anfibios son animales
                vertebrados que se caracterizan por sus peculiaridades
                anatómicas, entre ellas, una piel muy fina y húmeda, por lo que
                parte de su respiración ocurre a través de la piel. Por otra
                parte, los reptiles son animales vertebrados con pieles
                resistentes y escamosas, y en algunos casos tienen caparazón.
              </p>
            }
            textSecondTab={
              <p>
                Su presencia se considera como un indicador muy valioso de la
                calidad del ambiente, ya que son muy sensibles a las actividades
                humanas y la contaminación ambiental. En el caso de los
                anfibios, constituyen uno de los grupos más sensibles a los
                disturbios en su hábitat, debido a su piel permeable, sus ciclos
                de vida acuáticos y terrestres y su marcada preferencia de
                hábitos, entre otros.
              </p>
            }
            textThirdTab={
              <p>
                Se recomienda monitorear la presencia de anfibios y reptiles en los fragmentos de bosque secundario y bosques de galería asociados a paisajes productivos. Se debe priorizar los sitios cercanos a cuerpos de agua: márgenes de arroyos, ríos, pozas o sitios con agua estancada, ya sean permanentes o estacionales. Algunos investigadores recomiendan realizar el monitoreo por transecto de avistamiento cada 6 meses. En cuanto a los anfibios, algunas especies pueden observarse en el día, pero en general son más activos en las noches.
              </p>
            }
          ></GroupInfoSection>
        </div>
      ) : (
        <div className="min-h-[100vh] grid grid-cols-1 h-full">
          <div className="bg-[#002E0F] left-0  lg:pl-24 md:pl-10 sm:pl-10 pl-10 pt-32 pr-36 h-fit">
            <GoToPage
              page="/grupos"
              side="left"
              name="Atrás"
              fontsize="text-lg"
              textColor="text-white"
              borderType="border-b-2"
              borderColor="border-white"
              iconSize="h-4"
              iconColor="invert"
              iconMargin="mr-5"
            ></GoToPage>
          </div>
          <div style={{"z-index":"1"}}>
            <GroupInfoSection
              webvrurl="https://niv5.vercel.app/"
              icon={ico_rana}
              title={<p>Herpetofauna</p>}
              subTitle={<p>Anfibios y reptiles</p>}
              textFirstTab={
                <p>
                  La herpetofauna está compuesta por los anfibios (por ejemplo,
                  ranas, sapos, salamandras) y los reptiles (tortugas,
                  serpientes, cocodrilos, lagartijas, etc.). Los anfibios son
                  animales vertebrados que se caracterizan por sus
                  peculiaridades anatómicas, entre ellas, una piel muy fina y
                  húmeda, por lo que parte de su respiración ocurre a través de
                  la piel. Por otra parte, los reptiles son animales vertebrados
                  con pieles resistentes y escamosas, y en algunos casos tienen
                  caparazón.
                </p>
              }
              textSecondTab={
                <p>
                  Su presencia se considera como un indicador muy valioso de la
                  calidad del ambiente, ya que son muy sensibles a las
                  actividades humanas y la contaminación ambiental. En el caso
                  de los anfibios, constituyen uno de los grupos más sensibles a
                  los disturbios en su hábitat, debido a su piel permeable, sus
                  ciclos de vida acuáticos y terrestres y su marcada preferencia
                  de hábitos, entre otros.
                </p>
              }
              textThirdTab={
                <p>
                 Se recomienda monitorear la presencia de anfibios y reptiles en los fragmentos de bosque secundario y bosques de galería asociados a paisajes productivos. Se debe priorizar los sitios cercanos a cuerpos de agua: márgenes de arroyos, ríos, pozas o sitios con agua estancada, ya sean permanentes o estacionales. Algunos investigadores recomiendan realizar el monitoreo por transecto de avistamiento cada 6 meses. En cuanto a los anfibios, algunas especies pueden observarse en el día, pero en general son más activos en las noches.
                </p>
              }
            ></GroupInfoSection>
            
          </div>
          
          <div className="relative w-full lg:h-full flex justify-center">
            <GroupsVideoFooter videoSource={bosque} />
           
            <img
            
              src={img_rana_planta}
              alt=""
              className="lg:w-[30rem] md:w-[25rem] sm:w-[15rem] w-[15rem] h-fit-content bottom-0 absolute "
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HerpetofaunaScreen;
